module.exports = __webpack_public_path__ + "img/state_gift.3ae89f66.png";